import { defineMessages } from 'react-intl';

const messages = defineMessages({
  addOnMarketplace: {
    description: 'add-on marketplace page name',
    defaultMessage: 'Add-Ons',
    id: 'QLdHTN',
  },
  addOnMarketplaceDescription: {
    description: 'add-on marketplace page description',
    defaultMessage:
      'Activate an Add-On to unlock the feature in ShipStation. Once active, you can configure the Add-On settings and begin using it.',
    id: 'HGdUeU',
  },
  perMonth: {
    description: 'per month abbreviation',
    defaultMessage: '{price}/mo',
    id: 'tGfjjb',
  },
  addOnsHeader: {
    description: 'header for the Add-Ons grid that displays all available add-ons',
    defaultMessage: 'Available',
    id: 'spnXAB',
  },
  yourAddOnsHeader: {
    description: 'header for the Your Add-Ons grid that displays all available add-ons',
    defaultMessage: 'Active',
    id: 'euzE6A',
  },
  noActiveAddOnsHeader: {
    description: 'header displayed when NONE of the Add-Ons available to the Seller are active',
    defaultMessage: 'You have not yet activated any Add-Ons',
    id: 't1qfoN',
  },
  noActiveAddOnsDescription: {
    description: 'description displayed under the header when NONE of the Add-Ons available to the Seller are active',
    defaultMessage: 'Activate add-ons to enhance your ShipStation workflows.',
    id: 'FNAlHt',
  },
});

export default messages;
